var bighouse = bighouse || {};

bighouse.searchDatepicker = (function () {

    function init() {
        if($("#searchDatePicker").length <= 0) {
            return false
        }

        var minDate = $('input[name="datefrom"]').attr('data-min');
        var maxDate = $('input[name="datefrom"]').attr('data-max');

        $('input[name="datefrom"]').daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            "parentEl": "#searchDatePicker",
            minDate: minDate,
            maxDate: maxDate,
            autoUpdateInput: false,
            "locale": {
                "format": "DD-MM-YYYY",
                cancelLabel: 'Clear dates',
                "daysOfWeek": [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                "firstDay": 1
            }
        }, function(start, end, label) {
            //item selected
            $('.drp-calendar.single .monthselect').parent().append("test");
        });

        $('input[name="datefrom"]').on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('DD-MM-YYYY'));
            manageExtraDays(picker.startDate.format('dddd')); // e.g. Monday, Sunday
            $('select[name=nights]').attr('disabled', false);
        });

        $('input[name="datefrom"]').on('cancel.daterangepicker', function(ev, picker) {
            //do something, like clearing an input
            $('input[name="datefrom"]').val('');
            bighouse.searchFilters.clearNights(true);
        });


        $('button.bespokeCloseBtn').on('click', function(){
            $('input[name="datefrom"]').data('daterangepicker').hide();
            //this.hide();
        });
        
        const targetNode = document.getElementById('searchDatePicker');

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: false, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            // for (const mutation of mutationList) {
            //     console.log(mutation);
            // }
            //check if calendar's tips is already added
            if($(".calendar-tips").length < 1) {
                AddDrpTips();
            }

            //add month+year select
            if($(".js-monthyearselect").length < 1) {
                switchToMonthYearSelect(minDate, maxDate);
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

    }

    function manageExtraDays(currentDay) {
        // Reset
        $('.js-extraDays').remove();

        // define specific addition for weekdays
        var extraDays = {
          "Monday" : [ 
            { value: -1, label: "---" },
            { value: 7, label: "7" },
            { value: 4, label: "4" }
          ],
          "Friday" : [ 
            { value: -1, label: "---" },
            { value: 7, label: "7" },
            { value: 3, label: "3" }
          ]
        };

        if(extraDays.hasOwnProperty(currentDay)) {
            $.each(extraDays[currentDay], function (k, v) {
                $(`<option class="js-extraDays"${v.value == -1 ? " disabled" : ""} value="${v.value}">
                        ${v.label}
                    </option>`).insertAfter(".js-nights-default");
            });
        }
    }

    function AddDrpTips() {
        //drpTps global variable defined in <head> section
        if (typeof drpTps === 'undefined' || drpTps === null) {
            return false;
        }
        $('.drp-buttons').append("<div class='calendar-tips'><div class='calendar-tips-container'><ol></ol></div></div>");
        $.each(drpTps, function() {
            $('.calendar-tips ol').append(`<li>${this}</li>`);
        });
    }

    function switchToMonthYearSelect(startDate, endDate) {
        //we have input dates in DD-MM-YYYY format. We need to convert them to ISO date format.
        var regex = /^\d{2}-\d{2}-\d{4}$/;
        if(startDate.match(regex) === null || endDate.match(regex) === null) {
            return false;
        }
        var [startStrDay, startStrMonth, startStrYear] = startDate.split("-");
        var startDateISO = new Date (startStrYear + "-" + startStrMonth + "-" + startStrDay);
        var [endStrDay, endStrMonth, endStrYear] = endDate.split("-");
        var endDateISO = new Date (endStrYear + "-" + endStrMonth + "-" + endStrDay);

        if(!moment(startDateISO).isValid() || !moment(endDateISO).isValid()) {
            return false;
        }
        //to get range between startDate and endDate in months we need to set days to some value e.g. 1 -> for matching purposes
        startDateISO.setDate(1);
        endDateISO.setDate(1);
        
        $('#searchDatePicker .month').addClass("monthyearselect-parent").append("<select class='monthyearselect js-monthyearselect'></select>");
        var monthYearCurrentvalue = JSON.stringify({month: $('.monthselect').val(), year:  $('.yearselect').val()});
        while(startDateISO <= endDateISO) {
            var value = JSON.stringify({month: startDateISO.getMonth().toString(), year: startDateISO.getFullYear().toString()});
            var label = moment(startDateISO).format("MMMM, YYYY");
            $('.monthyearselect').append(`<option${value == monthYearCurrentvalue ? " selected" : ""} value=${value}>${label}</option>`);
            startDateISO.setMonth(startDateISO.getMonth() + 1);
        }
    }
    //hook into month and year select
    $(document).on('change', '.js-monthyearselect', function() {
        var monthyearselectValue = $(this).val();
        var monthyearselectValueObj = JSON.parse(monthyearselectValue);
        $('.yearselect').val(monthyearselectValueObj.year).change(); $('.monthselect').val(monthyearselectValueObj.month).change();
    });

    return {
        init: init
    };
})();